import { Create } from '@fund/api-modules';
import { getApiHostWithoutEnv } from '@fund/api-host';
import CreateByUser from './decorator/CreateByUser';
import fundCoreModel from '../model/fund-core.model';
import TransformResponse from './decorator/TransformResponse';
import fundOfferAccModel from '../model/fund-offer-acc.model';
import publicNetValueModel from '../model/public-net-value.model';
import publicGoldTrendModel from '../model/public-gold-trend.model';
import historyNetValueModel from '../model/history-net-value.model';
import stopWatch from '../model/stop-watch.model';
import highEndCore from '../model/high-end-core.model';
import highEndAccModel from '../model/high-end-acc.model';
import highEndNetValueModel from '../model/high-end-net-value.model';

@CreateByUser({
  getUserParams: (userInfo) => {
    const {
      utoken, ctoken, uid, deviceid,
    } = userInfo;
    return {
      utoken,
      ctoken,
      deviceid,
      version: '6.5.5',
      customerNo: uid,
      mobileKey: deviceid,
      product: 'EFund',
      plat: 'web',
    };
  },
})
@Create({
  baseURL: getApiHostWithoutEnv('fundcomapi'), // 更多地址参考 https://acttest.1234567.com.cn/topic/2019/fund-config/api
  // baseURL: 'https://fundcomapi.tiantianfunds.com',
  params: {
    deviceid: '1234567.py.service',
    version: '6.5.5',
    appVersion: '6.5.5',
    product: 'EFund',
    plat: 'Iphone',
  },
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
})
class FundCom {
  @TransformResponse((res) => fundCoreModel.objectWithKeyValues(res?.data[0]))
  getPublicOfferCoreData(param) {
    return this.POST('/mm/newCore/FundCoreDiyNew', {
      ...param,
      FIELDS:
        'SHORTNAME,RZDF,DWJZ,LJJZ,SYL_1N,SYL_LN,FSRQ,ISBUY,DTZT,FTYPE,FCODE,ISSALES,ISSBDATE,ISSEDATE,TSRQ,BACKCODE,MINSG,MINSBSG,SHZT,SGZT,SOURCERATE,RATE,REALSGCODE,FEATURE,SYL,MINRG,SYL_Z,BFUNDTYPE,QDTCODE,MINDT,BAGTYPE,FUNDTYPE,BENCH,ESTABDATE,,SELLSTATE,ESTDIFF,SYSDATE,PTYPE,FUNDTYPE,ISEXCHG,ISNEW,BTYPE',
    });
  }

  getFundBaseInfo(params) {
    return this.POST('/mm/FundMNewApi/FundBaseInfos', {
      FIELDS: 'SHORTNAME,SYL_1N,ESTABDATE,SYL_6Y,SYL_3N',
      ...params,
    });
  }

  // 公募基金-累计收益
  @TransformResponse((res) => fundOfferAccModel.objectWithKeyValues(res || {}))
  getPublicFundAccClassify(params) {
    return this.GET('/mm/newCore/FundVPageAccV1', {
      ...params,
    });
  }

  // 公募基金-单位净值
  @TransformResponse((res) => publicNetValueModel.objectWithKeyValues(res || {}))
  getPublicFundNetValue(params) {
    return this.GET('/mm/newCore/FundVPageDiagramNew', {
      ...params,
    });
  }

  // 公募基金-金价走势-不需要fundCode
  @TransformResponse((res) => publicGoldTrendModel.objectWithKeyValues(res || {}))
  getPublicOfferGoldData(params) {
    return this.POST('/mm/FundIndex/FundIndexPrice', {
      ...params,
    });
  }

  // 新历史净值分页接口
  @TransformResponse((res) => historyNetValueModel.objectArrayWithKeyValuesArray(res?.data || []))
  getPublicFundDiagramPageSort(param) {
    return this.GET('/mm/newCore/FundDiagramPageSort', param);
  }

  // 旗下相关ETF信息
  getETFInfo(params) {
    return this.POST('/mm/FundCustom/getSameETFInfo', params);
  }

  // 估值实时点位
  getValuationLast(params) {
    return this.POST('/mm/newCore/FundValuationLast', {
      FIELDS: 'GSZZL,GZTIME,GSZ',
      ...params,
    });
  }

  // 码表
  @TransformResponse((res) => stopWatch.objectArrayWithKeyValuesArray(res?.data || []))
  getFundStopWatchList(FCODES) {
    return this.GET('/mm/FundMNewApi/FundStopWatchList', {
      FCODES,
      FIELDS: 'T,F,P',
    });
  }

  // 高端理财核心接口数据
  @TransformResponse((res) => highEndCore.objectWithKeyValues(res?.data?.[0] || {}))
  getHighEndCoreData(fundCode) {
    return this.POST('/mm/newCore/FundCoreDiyNew', {
      FCODES: fundCode,
      FIELDS:
        'ISSBDATE,ISSEDATE,SELLSTATE,SELLSTATE2,ISNEW,BTYPE,FUNDTYPE,SHORTNAME,FEATURE,FTYPE,ESTABDATE,PROFITANNUAL,JZRQ,NAV,Y,SE,OVERCARRY,PROFITANNUAL,ANNUAL,ISSALES',
    });
  }

  // 高端理财-累计收益
  @TransformResponse((res) => highEndAccModel.objectWithKeyValues(res || {}))
  getHighEndAccEnjoy(params) {
    return this.GET('/mm/FundGDLC/fundAccWithSimilarAvg', params);
  }

  // 高端理财-历史净值
  @TransformResponse((res) => highEndNetValueModel.objectWithKeyValues(res || {}))
  getHighEndDiagram(params) {
    return this.GET('/mm/FundGDLC/FundDiagram', params);
  }

  // 高端理财接口FundIndexDiy获取指数信息
  getFundIndexDiyData(FCODES) {
    return this.POST('/mm/FundIndex/FundIndexDiy', {
      FCODES,
      FIELDS: 'W,M,Q,HY,Y,TWY,TRY,FY,SE,SY,INDEXNAME,EUTIME',
    });
  }

  // 高端理财历史净值-分页排序
  getHighEndDiagramPageSort(fundCode) {
    return this.GET('/mm/FundGDLC/FundDiagramPageSort', {
      FCODE: fundCode,
      pageIndex: 1,
      pageSize: 5,
    });
  }
}

const fundCom = new FundCom();

export default fundCom;
